import { parseResponse } from '$lib/client/responseHelpers';

import { client } from '@api/client';
import type { Message, MessageReceived } from '@api/types';

export const sendMessage = async (message: Message): Promise<MessageReceived> => {
    const data = await client.POST('/message/send', {
        body: message,
    });
    return parseResponse(data);
};